import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'

const ServiceTitleItem = (props) => {
  const { service_name, services, handleServiceAddDialogOpen } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const [title, setTitle] = useState('')
  const [isIdentityProvider, setIsIdentityProvider] = useState(false)

  const serviceTitleWrapperStyle = {
    height: '134px',
    background: theme.palette.greenSheen,
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px 0px 0px 10px',
    color: 'white',
    fontSize: '14px',
    fontWeight: '500',
    position: 'relative',
    marginBottom: '20px',
  }

  const serviceTitlePlusStyle = {
    position: 'absolute',
    top: '3px',
    left: '3px',
    color: 'white',
  }

  const titleStyle = {
    textAlign: 'center',
    fontSize: width >= constants.xlBreakpoint ? '14px' : '12px',
  }

  const handleClickAdd = () => {
    handleServiceAddDialogOpen({
      service_name,
      title: defaultTexts.add + ' ' + title + ' ' + defaultTexts.service,
    })
  }

  useEffect(() => {
    const filtered_services = services.filter(item => item.service === service_name)
    
    setTitle(filtered_services.length > 0 ? filtered_services[0].title.value : '')

    let is_identity_provider = false

    filtered_services.forEach(item => {
      if (item.config_params.is_identity_provider) {
        is_identity_provider = true
      }
    })

    setIsIdentityProvider(is_identity_provider)    
  }, [service_name, services])

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='center'
      sx={serviceTitleWrapperStyle}
    >
      <Box sx={titleStyle}>{title}</Box>
      {
        (editPermission && !isIdentityProvider) &&
        <IconButton sx={serviceTitlePlusStyle} onClick={handleClickAdd}>
          <AddCircleOutlineIcon sx={{ fontSize: '32px' }} />
        </IconButton>
      }      
    </Stack>
  )
}

export default ServiceTitleItem